<template>
  <div
    id="carga-masiva"
    style="background-color: #ededed; width: 100%"
    class="pt-3 pl-3"
  >
    <template>
      <v-layout>
        <v-flex class="titCargamMasiva" xs4>
          Carga masiva&nbsp;
          <v-tooltip bottom>
            <span slot="activator"
              ><v-icon dark color="grey" x-small>help</v-icon></span
            >
            <span
              >Deben coincidir los títulos del encabezado en la carga respetando
              mayúsculas y minúsculas.</span
            >
          </v-tooltip>
        </v-flex>
        <v-flex xs4>
          <v-btn class="btnDescargaCargaMasiva" @click="downloadTemplate()"
            >Descarga plantilla</v-btn
          >
        </v-flex>
        <v-flex xs12>
          <v-toolbar-title
            v-if="desactivarUpload == true && botonValida == 1"
            class="font-italic font-weight-light"
            >Validando que el archivo contenga <br />datos correctos, por favor
            espere...</v-toolbar-title
          >
        </v-flex>
        <v-flex xs4 grid-list-xl>
          <data-adjunto
            v-if="botonValida == 1 && desactivarUpload == false && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
            :documentoId="id"
            :tipeView="tipeView"
            :tipeArchive="tipeArchive"
            :clase="clase"
          ></data-adjunto>
        </v-flex>
        <v-flex xs4 order-md4 :key="botonLoad">
          <v-btn
            v-if="botonValida == 1 && getCodigoPerfil() !== 'LEC' && !isContratoCerrado()"
            class="btnValidarCargaMasiva"
            title="Validar planilla"
            :disabled="desactivarUpload == true ? true : false"
            @click="validateDocument()"
            >Validar</v-btn
          >
        </v-flex>
      </v-layout>
      <!-- antiguo modal -->
      <v-dialog v-model="dialogValidation" persistent max-width="600">
        <v-card>
          <v-card-title class="headline"
            >Resumen Validaci&oacute;n</v-card-title
          >
          <v-card-text>
            <v-flex lg12>
              <v-spacer></v-spacer>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
              </v-card-actions>
              <p>{{ resp }}</p>
              <p v-if="resp != '' && resp !== undefined && resp != null">
                <b>** El archivo debe adecuarse **</b>
              </p>
              <div v-else class="text-resp">
                <v-icon class="ico-resp">check_circle</v-icon>
                <p>
                  <b>El archivo esta correcto**</b>
                </p>
              </div>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeModal()"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- nuevo modal despliegue errores validacion -->
      <v-dialog v-model="newDialogValidationError" persistent max-width="600">
        <v-card>
          <v-card-title class="headline"
            >Resumen validaci&oacute;n</v-card-title
          >
          <v-card-text>
            <v-flex lg12>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
              </v-card-actions>
              <div class="text-xs-center">
                <i
                  class="fa fa-times-circle text-danger fa-4x"
                  aria-hidden="true"
                  style="color: #bb0000"
                ></i
                ><br />
                <b>El archivo tiene observaciones a corregir</b>
              </div>
              <ul v-for="(values, title) in resp" :key="title">
                <li>{{ title }}</li>
                <ul>
                  <li v-for="(value, index) in values" :key="index">
                    {{ value }}
                  </li>
                </ul>
              </ul>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="closeModal()"
              >Aceptar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- nuevo modal despliegue carga archivo (validacion ok!) -->
      <v-dialog v-model="newDialogCarga" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Estado carga</v-card-title>
          <v-card-text>
            <v-flex lg12>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
              </v-card-actions>
              <div class="text-resp text-xs-center">
                <i
                  class="fa fa-check-circle text-danger fa-5x pb-3"
                  aria-hidden="true"
                  style="color: #25bb00"
                ></i
                ><br />
                <p>
                  <b>El archivo cumple las condiciones para ser cargado</b>
                </p>
                <v-btn color="primary" flat @click="closeModal()"
                  >Cancelar</v-btn
                >&nbsp;&nbsp;<v-btn color="primary" @click="saveDocument()"
                  >Cargar</v-btn
                >
              </div>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- nuevo modal carga OK -->
      <v-dialog v-model="newDialogCargaOk" persistent max-width="600">
        <v-card>
          <v-card-title class="headline">Resumen Carga</v-card-title>
          <v-card-text>
            <v-flex lg12>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
              </v-card-actions>
              <div class="text-resp text-xs-center">
                <i
                  class="fa fa-check-circle text-danger fa-5x pb-3"
                  aria-hidden="true"
                  style="color: #25bb00"
                ></i
                ><br />
                <p>
                  <b>El archivo se ha cargado correctamente</b>
                </p>
                <v-btn color="primary" @click="finCarga()">Cerrar</v-btn>
              </div>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-dialog>
      <div v-if="loadingCarga">
        <loading></loading>
      </div>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </template>
  </div>
</template>
<script>
import axios from "axios";
import DataAdjunto from "@/components/AdjuntoData.vue";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import jwtDecode from "jwt-decode";

export default {
  name: "carga-masiva",
  components: {
    LoadingDescarga,
    Loading,
    DataAdjunto,
  },
  props: {
    apiValidateDocument: String,
    apiSaveDocument: String,
    apiDownloadDocument: String,
    templateTitle: String,
    tipoCarga: {
      type: String,
      default: "EXCEL",
    },
    tipeView: String,
  },

  data() {
    return {
      desactivarUpload: false,
      dialogValidation: false,

      newDialogValidationError: false,
      newDialogCarga: false,
      newDialogCargaOk: false,

      loadingCarga: false,
      dialogLoading: false,
      botonProcesar: false,
      botonCargar: true,
      alerta: false,
      botonDescarga: false,
      dialogArchivo: false,
      resp: "",
      id: "",
      idContrato: "",
      idUserLogged: "",
      tipeArchive: ".pdf,.doc,.docx,.jpg,.png,.xlsx",
      tab: "",
      botonLoad: 10,
      adminAdjunto: 20,
      botonValida: 1,
      clase: "btnSubirCargaMasiva",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 1000);
    },
  },
  created() {
    this.idUserLogged = this.$store.getters.userLogged.id;
    this.idContrato = this.$store.getters.contratoStored;
    if (this.tipoCarga == "CSV") {
      this.tipeArchive = ".csv"; // dsoto 18-10-2022
    }
    //  console.log("stringify:" + JSON.stringify(this.$props, null, 2));
    //  console.log("tipoCarga!!" + this.tipoCarga);
    //  console.log("tipeArchive!!" + this.tipeArchive);
  },

  mounted() {},
  computed: {
    
  },
  methods: {
    getCodigoPerfil() {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);
      const user = decoded.dto;
      // console.log("DEVO}DED USER:", user);
      return user.perfil.codigo
    },
    isContratoCerrado() {
      const contratoCerradoConId = JSON.parse(localStorage.getItem("contratoCerradoConId"));
      if (contratoCerradoConId && contratoCerradoConId.id === this.idContrato) {
        return contratoCerradoConId.cerrado;
      }
      return false;
    },
    closeModal() {
      this.loadingCarga = false;
      this.dialogLoading = false;
      this.botonValida = 1;

      this.dialogValidation = false;

      (this.newDialogValidationError = false),
        (this.newDialogCarga = false),
        (this.newDialogCargaOk = false),
        (this.resp = "");
      this.base64Value = undefined;
    },
    finCarga() {
      (this.newDialogCargaOk = false), this.$parent.loadData();
    },

    async validateDocument() {
      this.loadingCarga = true;
      this.desactivarUpload = true;

      if (this.base64Value != undefined) {
        this.resp = await this.preProcessFile();
      } else {
        this.resp = { "Error: ": ["Debe seleccionar el archivo"] };
      }

      this.loadingCarga = false;
      this.desactivarUpload = false;
      //nuevos modales
      if (this.resp != null && this.resp !== undefined && this.resp != "") {
        this.newDialogValidationError = true;
      } else {
        this.newDialogCarga = true;
      }
    },
    async preProcessFile() {
      let idContrato = this.$store.getters.contratoStored;
      // console.log("Carga Masiva, idcontrato::" + idContrato);
      if (this.tipoCarga != "EXCEL") {
        this.body = {
          documento: this.base64Value,
          idContrato: idContrato,
        };
        // console.log("no excel");
      } else {
        this.body = {
          excelFile: this.base64Value,
          idContrato: idContrato,
        };
        // console.log("SI excel");
      }

      return await axios
        .post(this.apiValidateDocument, this.body)
        .then((response) => {
          return response.data;
        })
        .then((rel) => {
          if (Object.keys(rel).length === 0) {
            this.botonValida = 2;
            this.reloadBoton();
          } else {
            return rel;
          }
        })
        .catch((error) => {
          if (error) {
            console.log(error.response);
            return { "Error: ": ["Ha ocurrido un error"] };
          }
        });
    },

    saveDocument() {
      this.loadingCarga = true;
      this.newDialogCarga = false;
      this.desactivarUpload = true;
      if (
        this.base64Value != null &&
        this.base64Value != "" &&
        this.base64Value !== undefined
      ) {
        let idContrato = this.$store.getters.contratoStored;
        let base64EncodedStr = this.base64Value;
        if (this.tipoCarga != "EXCEL") {
          this.body = {
            documento: base64EncodedStr,
            idContrato: idContrato,
            nombreArchivo: this.filenameValue,
          };
        } else {
          this.body = {
            nombreArchivo: this.filenameValue,
            excelFile: base64EncodedStr,
            idContrato: idContrato,
          };
        }

        axios
          .post(this.apiSaveDocument, this.body)
          .then((res) => {
            this.resp = res.data;
            this.loadingCarga = false;
            this.desactivarUpload = false;
            this.newDialogCargaOk = true;
            this.botonValida = 1;
            this.desactivarUpload = false;
          })
          .catch((error) => {
            if (error) {
              console.log(error.response);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
              this.loadingCarga = false;
              this.desactivarUpload = false;
            }
            return [];
          });
      } else {
        window.getApp.$emit("APP_ADMIN_FIELD");
        this.loadingCarga = false;
        this.desactivarUpload = false;
      }
    },

    downloadTemplate() {
      this.dialogLoading = true;
      let filename = this.templateTitle;
      // console.log("downloadTemplate1:" + filename + "::::::::");
      if (this.tipoCarga == "CSV") {
        filename += ".csv";
      } else {
        //por defecto EXCEL
        filename += ".xlsx";
      }
      // console.log("downloadTemplate2:" + filename + "::::");

      axios({
        url: this.apiDownloadDocument + this.idContrato,
        method: "GET",
        responseType: "blob",
      })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    reloadBoton() {
      this.botonLoad += 11;
    },
    reloadAdmin() {
      this.adminAdjunto += 21;
    },

    reload() {
      setTimeout(() => {
        this.$parent.reloadDocumento();
      }, 1000);
    },
  },
};
</script>